import * as React from "react";
import PageHeader from "./header/PageHeader";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import TopButton from "./topbutton/TopButton";
import Navbar from '../misc/Navbar'
import {ThemeProps} from "../styles/themeprops";

type PageLayoutProps = {
  children?: React.ReactNode;
  title: string;
  narrow?: boolean;
  theme:ThemeProps
};
//      <Navbar/>
////<PageHeader>{title}</PageHeader>
export default function PageLayout({
  children,
  title,
  narrow,
  theme,
}: PageLayoutProps) {
  const maxWith = narrow ? "max-w-2xl" : "max-w-7xl";
  const className = `${maxWith} mx-auto py-6 sm:px-6 lg:px-8`;
  return (
    <div>

      <Header theme={theme} />
      <main className={className}>{children}</main>
      <Footer theme={theme}>{children}</Footer>
      <TopButton theme={theme} />
    </div>
  );
  
}

export function AnonymousPageLayout({
  children,
  title,
  narrow,
  theme,
}: PageLayoutProps) {
  const maxWith = narrow ? "max-w-2xl" : "max-w-7xl";
  const className = `${maxWith} mx-auto py-6 sm:px-6 lg:px-8`;
  return (
    <div>
      <Navbar />
      <PageHeader>{title}</PageHeader>
      <main className={className}>{children}</main>
      <Footer theme={theme}>{children}</Footer>
      <TopButton theme={theme}/>
    </div>
  );
}